import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPasswordStars: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconPasswordStars"><Path d="M1 17.5L23 17.5" stroke="currentColor"/><Path d="M9 9.4981H15M13.5 12.0962L10.5 6.90002M10.5 12.0962L13.5 6.90009" stroke="currentColor"/><Path d="M17 9.4981H23M21.5 12.0962L18.5 6.90002M18.5 12.0962L21.5 6.90009" stroke="currentColor"/><Path d="M1 9.4981H7M5.5 12.0962L2.5 6.90002M2.5 12.0962L5.5 6.90009" stroke="currentColor"/></CentralIconBase>;
});

export default IconPasswordStars;
